import { DeepReadonly, readonly, Ref, ref } from 'vue'

interface UseLoading {
  startLoading: () => void
  stopLoading: () => void
  loading: DeepReadonly<Ref<boolean>>
}

const loading = ref<boolean>(false)

export function useLoading (): UseLoading {
  return {
    startLoading: () => { loading.value = true },
    stopLoading: () => { loading.value = false },
    loading: readonly(loading),
  }
}
